import React from "react";
import { Stack } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

// Components
import MKButton from "components/MKButton";

// Styles
import { StyledPaginationDots, StyledButtonContainer } from "index.styles";

const SliderNavigation = ({
  onSelect, // TESTING
  onPrevious,
  onNext,
  currentIndex,
  totalItems,
  showLeftButton = true,
  showRightButton = true,
  paginationDots = { type: "linear", small: false },
  sx = {},
  ...props
}) => {

  const renderPaginationDots = () => {
    if (paginationDots.type === "circular") {
      // Testimonials pattern: show [-1, 0, 1] dots
      return [-1, 0, 1].map((offset) => {
        const index = (currentIndex + offset + totalItems) % totalItems;
        return <StyledPaginationDots onClick={() => onSelect(index, currentIndex)} key={index} currentindex={currentIndex} index={index} small={paginationDots.small} />;
      });
    } else {
      // ResourcesSlider pattern: show linear dots based on totalItems
      const numDots = paginationDots.totalDots || Math.ceil(totalItems / 2);
      return Array.from({ length: numDots }, (_, index) => (
      // return Array.from({ length: 4 }, (_, index) => (
        <StyledPaginationDots onClick={() => onSelect(index, currentIndex)} key={index} currentindex={currentIndex} index={index} small={paginationDots.small} />
      ));
    }
  };

  return (
    <StyledButtonContainer
      sx={{
        justifyContent: "center",
        display: "flex",
        gap: 4,
        mt: 3,
        alignItems: "center",
        ...sx,
      }}
      {...props}
    >
      <MKButton size="small" variant="contained" color="secondary" aria-label="Previous Page" onClick={onPrevious} disabled={!showLeftButton}>
        <ChevronLeftIcon aria-hidden="false" />
      </MKButton>

      <Stack direction="row" spacing={1}>
        <Stack direction="row" spacing={1}>
          {renderPaginationDots()}
        </Stack>
      </Stack>

      <MKButton
        size="small"
        variant="contained"
        color="secondary"
        aria-label="Next Page"
        onClick={onNext}
        disabled={!showRightButton}
        sx={{ cursor: !showRightButton ? "grab !important" : "pointer" }}
      >
        <ChevronRightIcon aria-hidden="false" />
      </MKButton>
    </StyledButtonContainer>
  );
};

export default SliderNavigation;
